import updateDocument from "../../helpers/updateDocument";

export default function updateNotificationData(firebase, { document, user }) {
	if (user?.id && document.notification && !document.notification?.seenBy.includes(user.id)) {
		return updateDocument(document.ref, {
			"notification.seenBy": firebase.firestore.FieldValue.arrayUnion(user.id),
		});
	}
}
